import { useUserApi } from '@/features/users';
import { useCallback, useEffect, useState } from 'react';
import type { IOrder, IAuthSignupFields } from '@/types';

export const useUser = (): IAuthSignupFields | undefined => {
  const userApi = useUserApi();
  const [user, setUser] = useState<IAuthSignupFields>();

  const fetchUser = useCallback(async () => {
    try {
      const data = await userApi.getUser();
      setUser(data);
    } catch (error) {
      console.error(error);
    }
  }, [userApi]);

  useEffect(() => {
    const controller = new AbortController();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchUser();
    return () => controller.abort();
  }, [fetchUser]);

  return user ?? undefined;
};

interface IUseFetchDocsReturnValue {
  docs?: IOrder[] | undefined;
  fetch: () => void;
  hasError: boolean;
  isLoading: boolean;
}

export const useFetchDocs = (): IUseFetchDocsReturnValue => {
  const userApi = useUserApi();
  const [docs, setDocs] = useState<IOrder[] | undefined>();
  const [state, setState] = useState({ isLoading: false, hasError: false });

  const fetchDocs = useCallback(async () => {
    setState({ isLoading: true, hasError: false });

    try {
      const data = await userApi.getDocs();
      setDocs(data);
      setState({ isLoading: false, hasError: false });
    } catch (error) {
      console.error(error);
    }
  }, [userApi]);

  useEffect(() => {
    const controller = new AbortController();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchDocs();
    return () => controller.abort();
  }, [fetchDocs]);

  return { docs, ...state, fetch: () => fetchDocs };
};
